import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

const navItems = [
  { name: 'About', path: '/about' },
  { name: 'Products', path: '/products' },
  { name: 'Technology', path: '/technology' },
  { name: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  const isHome = location.pathname === '/';
  const heroNav = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        heroNav
          ? 'bg-white/10 backdrop-blur-xl border-b border-white/15'
          : scrolled
            ? 'bg-white/85 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_4px_24px_rgba(15,23,42,0.06)]'
            : 'bg-white/60 backdrop-blur-lg border-b border-slate-200/40'
      }`}
    >
      <div className="page-container-wide flex items-center justify-between h-16 md:h-[4.25rem]">
        <Link to="/" className="flex items-center gap-3 group">
          <span className={`shrink-0 h-9 w-9 md:h-10 md:w-10 rounded-full flex items-center justify-center transition-transform group-hover:scale-105 ${
            heroNav ? 'bg-black/50 ring-2 ring-white/30' : 'bg-slate-100 ring-1 ring-slate-200'
          }`}>
            <img src="/Logo.png" alt="Tavas" className="h-6 w-6 md:h-7 md:w-7 object-contain" />
          </span>
          <span className={`hidden sm:block text-sm md:text-base font-semibold ${heroNav ? 'text-white' : 'text-slate-900'}`}>
            Tavas Industries
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? heroNav ? 'text-cyan-300' : 'text-cyan-700'
                  : heroNav ? 'text-white/85 hover:text-white' : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/contact?subject=evaluation" className="btn-primary !py-2.5 !px-5 text-sm">
            Enquire
          </Link>
        </div>

        <button
          type="button"
          className={`lg:hidden p-2 ${heroNav ? 'text-white' : 'text-slate-800'}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass-surface border-t border-slate-200/60 mx-3 mb-3 rounded-2xl px-5 py-4 space-y-1 shadow-lg">
          {[{ name: 'Home', path: '/' }, ...navItems].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="block py-3 text-sm text-slate-600 hover:text-cyan-700"
            >
              {item.name}
            </Link>
          ))}
          <Link to="/contact?subject=evaluation" className="btn-primary w-full mt-3 text-center block">
            Enquire
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
